import { h } from '@stencil/core';

interface EvaMessageProps {
  title?: string;
  description: string;
  className?: string;
  type: 'ERROR' | 'WARNING' | 'INFO' | 'SUCCESS';
}

export default function EvaMessage({ title, description, className = '', type }: EvaMessageProps) {
  const iconByType = {
    ERROR: 'eva-3-icon-error-circle-filled',
    WARNING: 'eva-3-icon-warning-filled',
    INFO: 'eva-3-icon-info-circle-filled',
    SUCCESS: 'eva-3-icon-checkmark-circle-filled',
  }[type];

  return (
    <div
      role="presentation"
      class={{
        'eva-3-message': true,
        '-error': type === 'ERROR',
        '-warning': type === 'WARNING',
        '-info': type === 'INFO',
        '-success': type === 'SUCCESS',
        [className]: true,
        '-no-title': typeof title === 'undefined',
      }}
    >
      <div class="message-icon-container">
        <i class={`${iconByType} message-icon`} />
      </div>
      {typeof title !== 'undefined' && (
        <div class="message-header">
          <h5 class="eva-3-h5 message-title">{title}</h5>
        </div>
      )}
      <div class="message-body">
        <div class="eva-3-p message-text">{description}</div>
      </div>
    </div>
  );
}
